<template>
  <div class="content">
    <Banner :bannerImg="$store.getters.getUrl('la01_banner')"></Banner>
    <LogoNameImg :logoNameImg="$store.getters.getUrl('la01_logoNameImg')"></LogoNameImg>
    <DownBtn></DownBtn>
    <Xianlu></Xianlu>
    <KindList></KindList>
    <HotList :popularImg="$store.getters.getUrl('la01_popularImg')" :iconUrl="$store.getters.getUrl('la01_popularTitle')"></HotList>
    <Bottom :bottomImg="$store.getters.getUrl('la01_bottomImg')"></Bottom>
  </div>
</template>

<script>
import Banner from "@page/landing/components/banner.vue";
import LogoNameImg from "@page/landing/components/logoNameImg.vue";
import Bottom from "@page/landing/components/bottom.vue";
import HotList from "@page/landing/components/hotList.vue";


import DownBtn from "@page/landing/template/la01/components/downbtn.vue";
import Xianlu from "@page/landing/template/la01/components/xianlu.vue";
import KindList from "@page/landing/template/la01/components/kindList.vue";

export default {
  components: {
    Banner,
    LogoNameImg,
    DownBtn,
    Xianlu,
    KindList,
    HotList,
    Bottom
  },
};
</script>

<style lang="scss" scoped>
.content{
  background: url('../../../../assets/base64Img/la01.jpg') center center;
  background-size: 100% 100%;
}
</style>
